import {timezoneSafeTimestamp} from '../core/time.js';
function required(value,label){
  if(typeof value!=='string'||!value.trim())throw new TypeError(label+' is required');
  return value.trim();
}
export function createCraftMeasurement({id,kind,unit,value,recordedAt,source,subjectId=null}={}){
  if(typeof value!=='number'||!Number.isFinite(value))throw new TypeError('value must be finite');
  if(!source||typeof source!=='object'||Array.isArray(source))throw new TypeError('source is required');
  return Object.freeze({
    id:required(id,'id'),kind:required(kind,'kind'),unit:required(unit,'unit'),value,
    recordedAt:timezoneSafeTimestamp(recordedAt,'recordedAt'),subjectId:subjectId==null?null:required(subjectId,'subjectId'),
    source:Object.freeze({kind:required(source.kind,'source.kind'),ref:source.ref==null?null:required(source.ref,'source.ref')})
  });
}
export function createCraftTimelineEvent({id,kind,recordedAt,source,subjectId=null}={}){
  return Object.freeze({id:required(id,'id'),kind:required(kind,'kind'),recordedAt:timezoneSafeTimestamp(recordedAt,'recordedAt'),source:required(source,'source'),subjectId:subjectId==null?null:required(subjectId,'subjectId')});
}
